import { defaultTokens } from "./defaultTokens";

/**
 * Internal immutable state
 */
let designSystem = {
  colors: defaultTokens.constColours,
  font: defaultTokens.font,
  radius: defaultTokens.borderRd,
  borderSz: defaultTokens.borderSz,
  styleDecider: defaultTokens.applyBackendColAndStyle,
};

const listeners = new Set();

/**
 * Read current design system
 */
export const getDesignSystem = () => designSystem;

/**
 * Subscribe for updates
 */
export const subscribeDesignSystem = (callback) => {
  //callback is a function
  listeners.add(callback);
  return () => listeners.delete(callback);
};

/**
 * Update design system from backend / tenant config
 */
export const updateDesignSystem = (uiConfig = {}) => {
  let nextDesignSystem = designSystem;
  
  if (designSystem.styleDecider) {
    nextDesignSystem = {
      ...designSystem,

      colors: {
        ...designSystem.colors,
        primary: {
          ...designSystem.colors.primary,
          ...(uiConfig.primaryColor && { main: uiConfig.primaryColor }),
        },
        secondary: {
          ...designSystem.colors.secondary,
          ...(uiConfig.secondaryColor && { main: uiConfig.secondaryColor }),
        },
        error: {
          ...designSystem.colors.error,
          ...(uiConfig.errorColor && { main: uiConfig.errorColor }),
        },
      },

      font: {
        ...designSystem.font,
        ...(uiConfig.fontFamily && {
          fontFamily: uiConfig.fontFamily,
        }),
      },

      radius: {
        ...designSystem.radius,
        ...(uiConfig.selectedTheme &&
          designSystem.radius[uiConfig.selectedTheme] && {
            default: designSystem.radius[uiConfig.selectedTheme],
          }),
      },
    };
  }

  /**
   * Update only if changed
   */
  if (nextDesignSystem !== designSystem) {
    designSystem = nextDesignSystem;
    // listeners.forEach((cb) => cb(designSystem));
    listeners.forEach((cb) => {
      try {
        if (typeof cb === "function") {
          cb(designSystem);
        }
      } catch (err) {
        // don't let one listener failure prevent others from running
        // eslint-disable-next-line no-console
        // console.error("designSystem listener error:", err);
      }
    });
  }
};
